<template>
  <div
    class="tw:flex tw:h-full tw:flex-grow tw:flex-col tw:border-0 tw:border-l-2 tw:border-solid tw:border-denim-200"
  >
    <div class="tw:flex tw:flex-wrap tw:gap-y-2 tw:px-4 tw:py-3">
      <slot name="header" />
    </div>

    <div
      v-if="isLoading"
      class="tw:mx-4 tw:flex-grow"
    >
      <LoadingBar />
    </div>
    <template v-else>
      <div
        v-if="pagination.pageCount"
        class="tw:h-full tw:flex-grow tw:overflow-y-auto tw:px-4 tw:max-w-[610px]"
      >
        <slot />
      </div>
      <div
        v-else
        class="tw:flex tw:h-full tw:w-full tw:flex-col tw:items-center tw:justify-center tw:text-center"
      >
        <slot name="no-data" />
      </div>
    </template>
    <Pagination
      v-if="!hashtagIsCurrentView"
      class="tw:border-1 tw:flex tw:justify-end tw:border-0 tw:border-t tw:border-solid tw:border-denim-200 tw:px-4 tw:py-2"
      :page-size-options="PAGINATION_PAGE_SIZE_OPTIONS"
      :pagination="pagination"
      @pagination-changed="emits('pagination-changed', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import { LoadingBar } from "shared/components/base";
import { type PaginationData, Pagination } from "shared/components/Pagination";

const PAGINATION_PAGE_SIZE_OPTIONS = [20, 40, 60];
import { inject } from "vue";

import {
  type UseHashtagContextReturn,
  HASHTAG_CONTEXT,
} from "./useHashtagContext";

const { hashtagIsCurrentView } =
  inject<UseHashtagContextReturn>(HASHTAG_CONTEXT)!;

defineProps<{
  isLoading: boolean;
  pagination: PaginationData;
}>();

const emits = defineEmits<{
  (e: "pagination-changed", pagination: PaginationData): void;
}>();
</script>
